const getRegularPlaceData = placeAddreess => {
  const postCodeData = placeAddreess.find(address =>
    address.types.includes("postal_code")
  );
  const routeNameData = placeAddreess.find(address =>
    address.types.includes("route")
  );
  const flatNumberData = placeAddreess.find(address =>
    address.types.includes("street_number")
  );
  const addressLine2Data = placeAddreess.find(address =>
    address.types.includes("administrative_area_level_2")
  );
  const cityData = placeAddreess.find(address =>
    address.types.includes("postal_town")
  );
  const totalData = {
    postalCode: (postCodeData && postCodeData.long_name) || null,
    routeName: (routeNameData && routeNameData.long_name) || null,
    flatNumber: (flatNumberData && flatNumberData.long_name) || null,
    city: (cityData && cityData.long_name.toLowerCase()) || null,
    addressLine2: (addressLine2Data && addressLine2Data.long_name) || null
  };
  return totalData;
};
export default getRegularPlaceData;
